import { render, staticRenderFns } from "./RejectVerificationModal.vue?vue&type=template&id=1f022800&"
import script from "./RejectVerificationModal.vue?vue&type=script&lang=js&"
export * from "./RejectVerificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports